// Nimny Lab — "Копилка Нимни" reward unit utilities.
// Unit name: "ним". Plural: 1 ним, 2-4 нима, 5+ нимов (standard Russian rules).
// No real-world currency conversion is exposed by these helpers.

// Russian pluralization for "ним" using the last-two-digits rule.
const pluralNim = (amount) => {
  const n = Math.abs(Math.trunc(amount));
  const mod100 = n % 100;
  const mod10 = n % 10;
  if (mod100 >= 11 && mod100 <= 14) return 'нимов';
  if (mod10 === 1) return 'ним';
  if (mod10 >= 2 && mod10 <= 4) return 'нима';
  return 'нимов';
};

// Format an amount with the correct "ним" plural form.
//   formatNims(1)  -> "1 ним"
//   formatNims(3)  -> "3 нима"
//   formatNims(7)  -> "7 нимов"
//   formatNims(21) -> "21 ним"
export const formatNims = (amount) => {
  const n = Number(amount) || 0;
  return `${n} ${pluralNim(n)}`;
};

// Read the reward block off a lesson regardless of which adapter shape it
// passes through. New lesson modules may also store reward inside `_content`.
export const getLessonReward = (lesson) => {
  if (!lesson) return null;
  return lesson.reward || lesson._content?.reward || null;
};

// Sum base + awarded bonuses, capped at lesson.reward.max so we never go
// over the explicit per-lesson ceiling, even if an extra bonus id sneaks in.
export const calculateLessonRewardTotal = (lessonReward, awardedBonusIds = []) => {
  if (!lessonReward) return 0;
  const base = Number(lessonReward.base) || 0;
  const bonuses = Array.isArray(lessonReward.bonuses) ? lessonReward.bonuses : [];
  const awarded = Array.isArray(awardedBonusIds) ? awardedBonusIds : [];
  const bonusSum = bonuses
    .filter((b) => awarded.includes(b.id))
    .reduce((acc, b) => acc + (Number(b.amount) || 0), 0);
  const max = Number(lessonReward.max) || base + bonusSum;
  return Math.min(base + bonusSum, max);
};

// Build a stable lesson key for storage. Some legacy days have id="day-1",
// new days use "max-week-1-day-3"; we always normalise to the new shape so
// the kopilka history is consistent across schema generations.
export const buildLessonKey = (studentId, weekId, dayId) =>
  `${studentId}-${weekId}-${dayId}`;
